// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { textWithIconsStyles } from "@sc/App/Widgets/TextWithIcons/TextWithIcons";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

textWithIconsStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 32px 16px;
        background-color: ${color("common.ui2")};
    `,
};

textWithIconsStyles.title = {
    size: 24,
    lineHeight: "32px",
    weight: "bold",
    css: css`
        margin-bottom: 20px;
    `,
};

textWithIconsStyles.icon = {
    width: "48px",
    height: "48px",
    css: css`
        overflow: visible;
    `,
};

textWithIconsStyles.tilesContainer = {
    css: css`
        display: flex;
        width: 100%;
        column-gap: 42px;
        flex-wrap: wrap;
        row-gap: 12px;
        ${xScreen("lte", "md")} {
            column-gap: 0;
        }
    `,
};

textWithIconsStyles.heading = {
    size: 18,
    lineHeight: "24px",
    weight: "bold",
    css: css`
        margin: 0;
    `,
};

textWithIconsStyles.tileWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 12px;

        ${({ width }: any) => {
            if (width === "100%") {
                return "flex-basis: 100%;";
            }
            if (width === "50%") {
                return css`
                    flex-basis: calc(50% - 21px);
                `;
                // eslint-disable-next-line no-else-return
            } else if (width === "33%") {
                return css`
                    flex-basis: calc((100% - 84px) / 3);
                `;
            } else {
                return css`
                    flex-basis: calc((100% - 126px) / 4);
                `;
            }
        }}

        ${xScreen("lte", "md")} {
            flex-basis: 50%;
        }
        ${xScreen("lte", 767)} {
            flex-basis: 100%;
        }
    `,
};

textWithIconsStyles.link = {
    css: css`
        flex-basis: 25%;
        gap: 12px;

        ${({ width }: any) => {
            if (width === "100%") {
                return "flex-basis: 100%;";
            }
            if (width === "50%") {
                return css`
                    flex-basis: calc(50% - 21px);
                `;
                // eslint-disable-next-line no-else-return
            } else if (width === "33%") {
                return css`
                    flex-basis: calc((100% - 84px) / 3);
                `;
            } else {
                return css`
                    flex-basis: calc((100% - 126px) / 4);
                `;
            }
        }}

        ${xScreen("lte", "md")} {
            flex: auto;
            flex-basis: 50%;
        }
        ${xScreen("lte", 767)} {
            flex-basis: 100%;
        }
    `,
};
